import React from "react";
import { useAuth } from "../services/auth/AuthContext";
import { Outlet, Navigate } from "react-router-dom";
import Loader from "../components/loader/loader";

const PrivateRoute = () => {
  const { isAuthenticated, loading, userAttributes } = useAuth();

  if (loading) {
    return (
      <div className="full-container">
        <Loader text="Cargando" />
      </div>
    );
  }
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
